// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__1iLM3","content_dark":"content_content_dark__3NU8U"};